export default function calculateProductPrice(old_price, config) {
  if (config.bank == 'liberty') {
    return old_price
  }

  if (config.pay_method == 'card' && false) {
    // no more card pay method
    return Math.round(old_price * 0.97)
  }

  if (config.pay_method == 'bank') {
    // no more card pay method
    return Math.round(old_price * 0.98)
  }

  return old_price
}
